import { deactivateWorkspace } from '@usehatchapp/javascript-sdk';
import { REMOVE_USERS_FROM_BOARD } from 'root/stores/teams';

import { constants } from '../constants';

export const doDeactivateBoard =
  ({ workspaceId, mongoId } = {}) =>
  async ({ dispatch, request }) => {
    const {
      DEACTIVATE_BOARD_REQUEST,
      DEACTIVATE_BOARD_SUCCESS,
      DEACTIVATE_BOARD_FAILURE,
    } = constants;

    try {
      dispatch({ type: DEACTIVATE_BOARD_REQUEST });

      await request(deactivateWorkspace, { workspaceId });

      // set archived to true in state
      dispatch({
        actions: [
          {
            payload: { boardId: mongoId },
            type: DEACTIVATE_BOARD_SUCCESS,
          },
          {
            payload: { boardId: mongoId },
            type: REMOVE_USERS_FROM_BOARD,
          },
        ],
        type: 'BATCH_ACTIONS',
      });

      // dispatch notification saying we successfully deactivated board
      dispatch({
        actionCreator: 'doCreateNotificationMessage',
        args: [{ message: 'Successfully deactivated Board.' }],
      });
    } catch (error) {
      dispatch({ error, type: DEACTIVATE_BOARD_FAILURE });
    }
  };
